import React, { useState, useEffect } from 'react';
import axios from 'axios';

const MailSablonlariPage = () => {
  const [sablonlar, setSablonlar] = useState([]);
  const [secili, setSecili] = useState(null);
  const [form, setForm] = useState({ konu: '', icerik: '' });
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  const yukle = () => axios.get('/api/admin/mail-sablonlari').then(r => { setSablonlar(r.data); if (r.data.length > 0 && !secili) { setSecili(r.data[0]); setForm({ konu: r.data[0].konu, icerik: r.data[0].icerik }); } }).catch(console.error);
  useEffect(() => { yukle(); }, []);

  const sablon = (s) => {
    setSecili(s);
    setForm({ konu: s.konu, icerik: s.icerik });
    setSonuc(null);
  };

  const handleKaydet = async () => {
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/admin/mail-sablonlari/' + secili.anahtar, form);
      setSonuc({ tip: 'basari', mesaj: 'Şablon güncellendi.' });
      yukle();
    } catch(err) {
      setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Hata oluştu.' });
    } finally { setYukleniyor(false); }
  };

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Mail Şablonları</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Sistem tarafından gönderilen maillerin içeriklerini düzenleyin.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '280px 1fr', gap: '1.5rem', alignItems: 'start' }}>
        {/* Sol - Şablon Listesi */}
        <div className="card" style={{ padding: '0.75rem' }}>
          {sablonlar.map(s => (
            <button key={s.anahtar}
              onClick={() => sablon(s)}
              style={{
                width: '100%', textAlign: 'left', padding: '0.6rem 0.75rem',
                border: 'none', borderRadius: 'var(--radius-sm)', cursor: 'pointer',
                background: secili?.anahtar === s.anahtar ? 'var(--mavi-acik)' : 'transparent',
                color: secili?.anahtar === s.anahtar ? 'var(--mavi)' : 'var(--yazi)',
                fontSize: '13px', fontWeight: secili?.anahtar === s.anahtar ? '500' : '400',
                marginBottom: '2px', display: 'block'
              }}>
              {s.baslik}
            </button>
          ))}
        </div>

        {/* Sağ - Düzenleme */}
        {secili ? (
          <div className="card">
            <div style={{ marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
              <h3 style={{ fontSize: '16px', fontFamily: 'DM Sans', fontWeight: '600', marginBottom: '4px' }}>{secili.baslik}</h3>
              <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{secili.aciklama}</p>
            </div>

            {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div className="form-group">
                <label>Mail Konusu</label>
                <input type="text" value={form.konu} onChange={e => setForm({ ...form, konu: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Mail İçeriği</label>
                <textarea
                  value={form.icerik}
                  onChange={e => setForm({ ...form, icerik: e.target.value })}
                  rows={12}
                  style={{ fontFamily: 'monospace', fontSize: '13px' }}
                />
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <button className="btn btn-primary" disabled={yukleniyor} onClick={handleKaydet}>
                  {yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}
                </button>
                <button className="btn btn-secondary" onClick={() => setForm({ konu: secili.konu, icerik: secili.icerik })}>
                  Sıfırla
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="card" style={{ textAlign: 'center', padding: '3rem', color: 'var(--yazi-ikincil)' }}>
            Düzenlemek için soldan bir şablon seçin.
          </div>
        )}
      </div>
    </div>
  );
};
export default MailSablonlariPage;
